export const getRootStepId = (graph = {}) => {
  const allSteps = new Set(Object.keys(graph));
  const childSteps = new Set();
  Object.values(graph).forEach((step) => {
    [step.exit, step.child, ...(step.branches || [])]
      .filter((n) => !!n)
      .forEach((n) => {
        childSteps.add(n);
      });
  });
  const rootSteps = new Set([...allSteps].filter((step) => !childSteps.has(step)));
  return Array.from(rootSteps)[0];
};
